
module.exports = {
	status: 'ready',
	notes: '',
	context: {
		title: 'Example List',
		items: [{
			title: 'FMV söker samordnare för beredskaps- och övningsverksamheten',
			preamble: '<p>På FMV utvecklar vi och levererar teknik, utrustning och tjänster som Försvarsmakten behöver för att försvara Sverige idag och imorgon. Nu kan du bli en del av oss och vara med och utveckla framtidens försvar.</p>',
			linkIcon: true,
			image: null,
			topRow: [
				{ icon: 'location', text: 'Ortsnamn' },
				{ icon: 'unit', text: 'Enhet' },
				{ text: 'Publicerad: 2020-01-23' }
			],
			bottomRow: [
				{ icon: 'calender', text: 'Senaste ansökningsdag: 2020-02-06' }
			]
		}, {
			title: 'FMV söker samordnare för beredskaps- och övningsverksamheten',
			preamble: '',
			linkIcon: true,
			image: null,
			topRow: [
				{ icon: 'location', text: 'Ortsnamn' },
				{ icon: 'unit', text: 'Enhet' },
				{ text: 'Publicerad: 2020-01-23' }
			],
			bottomRow: [
				{ icon: 'calender', text: 'Senaste ansökningsdag: 2020-02-06' }
			]
		}, {
			title: 'Systemingenjör Varnar/Motmedel',
			preamble: '<p>Har du kunskap om varnar/motmedel? Är du van vid att arbeta med komplicerade, tekniska projekt i en större organisation? Är du strukturerad och trivs med att samarbeta med andra och arbeta i team? Då är detta en spännande utmaning för dig!</p>',
			linkIcon: false,
			image: '/images/demo-soldat-2.jpg',
			topRow: [
				{ icon: 'news', text: 'news' },
				{ text: '01 maj 2019' }
			]
		}, {
			title: 'Produktledare Hälso- och sjukvårdssystem',
			preamble: '<p>På FMV utvecklar vi och levererar teknik, utrustning och tjänster som Försvarsmakten behöver för att försvara Sverige idag och imorgon. Nu kan du bli en del av oss och vara med och utveckla framtidens försvar.</p>',
			linkIcon: false,
			image: null,
			topRow: [
				{ icon: 'project', text: 'project' },
				{ text: '01 maj 2019' }
			]
		}],
		jobList: {
			title: 'Lediga Jobb',
			divider: true,
			items: [{
				title: 'FMV söker samordnare för beredskaps- och övningsverksamheten',
				preamble: '<p>På FMV utvecklar vi och levererar teknik, utrustning och tjänster som Försvarsmakten behöver för att försvara Sverige idag och imorgon. Nu kan du bli en del av oss och vara med och utveckla framtidens försvar.</p>',
				linkIcon: true,
				image: null,
				topRow: [
					{icon: 'location', text: 'Ortsnamn'},
					{icon: 'unit', text: 'Enhet'},
					{text: 'Publicerad: 2020-01-23'}
				],
				bottomRow: [
					{icon: 'calender', text: 'Senaste ansökningsdag: 2020-02-06'}
				]
			},{
				title: 'FMV söker en ingenjör till sektionen Ammunition, Skydd och CBRN',
				preamble: '<p>På FMV utvecklar vi och levererar teknik, utrustning och tjänster som Försvarsmakten behöver för att försvara Sverige idag och imorgon. Nu kan du bli en del av oss och vara med och utveckla framtidens försvar</p>',
				linkIcon: true,
				image: null,
				topRow: [
					{ icon: 'location', text: 'Ortsnamn' },
					{ icon: 'unit', text: 'Enhet' },
					{ text: 'Publicerad: 2020-01-23' }
				],
				bottomRow: [
					{ icon: 'calender', text: 'Senaste ansökningsdag: 2020-02-06' }
				],
				icon: 'news',
				date: '01 maj 2019'
			},{
				title: 'FMV söker samordnare för beredskaps- och övningsverksamheten',
				preamble: '',
				linkIcon: true,
				image: null,
				topRow: [
					{ icon: 'location', text: 'Ortsnamn' },
					{ icon: 'unit', text: 'Enhet' },
					{ text: 'Publicerad: 2020-01-23' }
				],
				bottomRow: [
					{ icon: 'calender', text: 'Senaste ansökningsdag: 2020-02-06' }
				]
			}]
		},
		searchList: {
			title: 'Sökresultat',
			items: []
		}
	},
};
